import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Button, Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import FeedbackModal from './FeedbackModal';
import { useDailyFeedback, useFeedbackQuestion } from 'redux/reducers/user/dashboard/tms-feedback';
import { BiEdit } from 'react-icons/bi';

const DailySession = () => {
  const [activeRoutineFeedback, setActiveRoutineFeedback] = useState<
    typeof dailyFeedback[0]['routine_session'] | null
  >(null);

  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);

  const [items, setItems] = useState({});

  const [feedbackQuestionRoutineId, setFeedbackQuestionRoutineId] = useState<number | null>(null);

  const [dailySessionId, setDailySessionId] = useState<number>();

  const { data: dailyFeedback = [], isLoading } = useDailyFeedback();

  const handleOpenFeedbackModal = (item: any) => {
    setItems(item);
    setOpenFeedbackModal(true);
  };

  const handleCloseFeedbackModal = () => {
    setOpenFeedbackModal(false);
  };

  const { data: feedbackQuestion } = useFeedbackQuestion(
    feedbackQuestionRoutineId?.toString() ?? '',
    'daily_session'
  );

  console.log(dailyFeedback);

  return (
    <>
      <FeedbackModal
        openFeedbackModal={openFeedbackModal}
        handleCloseFeedbackModal={handleCloseFeedbackModal}
        feedbackQuestionRoutineId={feedbackQuestionRoutineId}
        dailySessionId={dailySessionId?.toString() || ''}
        items={items}
      />
      <Box>
        {dailyFeedback?.map((item, index) => {
          return (
            <>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
                sx={{
                  backgroundColor: `${index % 2 === 0 ? '#edeff0' : 'white'}`,
                  p: 1.5
                }}>
                <Typography> session : {item.course_topic.title}</Typography>
                {item?.feedback_submit_status == false ? (
                  <IconButton
                    color="primary"
                    aria-label="add to shopping cart"
                    onClick={() => {
                      handleOpenFeedbackModal(item);
                      setActiveRoutineFeedback(item?.routine_session || null);
                      setFeedbackQuestionRoutineId(item?.routine_session?.routine);
                      setDailySessionId(item?.id);
                    }}>
                    <BiEdit />
                  </IconButton>
                ) : (
                  <Button
                    style={{
                      background: '#006ECB',
                      color: '#fff',
                      fontSize: '12px',
                      height: '22px'
                    }}>
                    Already Submitted
                  </Button>
                )}
              </Stack>
            </>
          );
        })}
      </Box>
    </>
  );
};

export default DailySession;
